import axios from "axios";

const getApiBaseUrl = () => {
  const source = localStorage.getItem("source");

  switch (source) {
    case "formaxpay":
      return "https://api.formaxpay.com/restapi/";
    case "rechargepos":
      //  return "http://192.168.0.110:5001/recharge_pos/";
      return "https://api.formaxpay.com/recharge_pos/";
    case "api":
    default:
      // return "http://192.168.0.110:5001/api/";
      return "https://api.formaxpay.com/api/";
  }
};

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

// Dynamically update baseURL and token before each request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  const baseURL = getApiBaseUrl();

  config.baseURL = baseURL;

  if (token) {
    config.headers["x-access-token"] = `${token}`;
  }

  return config;
});

export default axiosInstance;
